import React from 'react'
import Map from './Map'
import useContent from '../../utils/content'
import { useDataQuery } from '../../hooks/useDataQuery'
import Img from '../general/Image'

// eslint-disable-next-line react/react-in-jsx-scope
const Contact = () => {
  const content = useContent(useDataQuery())

  let mapUrl = ''
  if (content.address) {
    mapUrl = `https://maps.google.com/?q=${content.address
      .replace(' ', '%20')
      .replace(',', '')
      .replace('<br>', '')}`
  }

  return (
    <section className='contact' id='contact'>
      <Img className='contact_img' src={content.mapImage} />
      <div className='container-small'>
        <div className='contact_cont'>
          <h2 className='sub-title'>{content.contactTitle}</h2>
          <a
            target='_blank'
            rel='noopener norefferer'
            className='general-link'
            href={content.contactTgLink}
          >
            {content.actionCtaTitle}
            <Img className='tg-icon' src='icons/telegram.svg' />
          </a>

          <div className='contact_cont_info'>
            <div className='general_item'>
              <Img
                className='general_paragraph_icon'
                src={content.phoneNumbersIcon}
              />
              <p className='general_paragraph'>
                {content.phoneNumbers.map(number => (
                  <a
                    key={Math.random()}
                    href={`tel:${number}`}
                    className='general_paragraph'
                  >
                    {number}
                  </a>
                ))}
              </p>
            </div>
            {content.address ? (
              <div className='general_item'>
                <Img
                  className='general_paragraph_icon'
                  src={content.addressIcon}
                />
                <a
                  className='external-map-link general_paragraph'
                  href={content.mapLink}
                  target='_blank'
                  rel='noopener noreferrer'
                  dangerouslySetInnerHTML={{ __html: content.address }}
                />
              </div>
            ) : null}
            {content.site ? (
              <a
                href={`https://${content.site}`}
                className='general_item'
                rel='noreferrer'
                target='_blank'
              >
                <Img
                  className='general_paragraph_icon'
                  src={content.siteIcon}
                />
                <p
                  className='general_paragraph'
                  dangerouslySetInnerHTML={{ __html: content.site }}
                />
              </a>
            ) : null}
            {content.email ? (
              <a href={`mailto:${content.emailIcon}`} className='general_item'>
                <Img
                  className='general_paragraph_icon'
                  src={content.emailIcon}
                />
                <p
                  className='general_paragraph'
                  dangerouslySetInnerHTML={{ __html: content.email }}
                />
              </a>
            ) : null}
          </div>
          <div className='contact_cont_info'>
            <div className='contact_cont_info_items--flex'>
              {content.contactSoz.map(data => {
                if (data.src) {
                  return (
                    <a
                      key={Math.random()}
                      href={data.src}
                      rel='noreferrer'
                      target='_blank'
                      className='contact_cont_info_items_link'
                    >
                      <Img src={data.img} />
                    </a>
                  )
                }

                return null
              })}
            </div>
            <div className='contact_cont_info_items'>
              <a
                href={content.mapLink}
                rel='noreferrer'
                target='_blank'
                className='contact_cont_btn'
              >
                {content.mapWayButton}
                <div className='contact_cont_btn_mapIcon' />
              </a>
            </div>
          </div>
          <div className='contact_cont_map'>
            <Map />
          </div>
          <div className='contact_cont_copyright'>{content.copyright}</div>
        </div>
      </div>
    </section>
  )
}

export default Contact
